import request from '@/http/request';

// 获取权限配置列表
export function getAuthorityList(params) {
  return request({
    url: '/api/v1/ops/authority_list',
    method: 'get',
    params,
  });
}

// 创建权限配置
export function createAuthority(data) {
  return request({
    url: '/api/v1/ops/authority_create',
    method: 'post',
    data,
  });
}

// 更新权限配置
export function updateAuthority(authorityId, data) {
  return request({
    url: `/api/v1/ops/authority_update/${authorityId}`,
    method: 'put',
    data,
  });
}

// 删除权限配置
export function deleteAuthority(authorityId) {
  return request({
    url: `/api/v1/ops/authority_delete/${authorityId}`,
    method: 'delete',
  });
}

// 获取权限配置详情
export function getAuthorityDetail(authorityId) {
  return request({
    url: `/api/v1/ops/authority/${authorityId}`,
    method: 'get',
  });
}